import React from 'react';
// import './index.css';
import reportWebVitals from './reportWebVitals';
import EvaDynamicSelect from "./defined/EvaDynamicSelect"
import EvaMultiDynamicSelect from "./defined/EvaMultiDynamicSelect";
import EvaMultiString from "./defined/EvaMultiString";
import EvaMultiInteger from "./defined/EvaMultiInteger";
import EvaMultiDate from "./defined/EvaMultiDate";
import EvaDate from "./defined/EvaDate";
import EvaDynamicSectionSelect from "./defined/EvaDynamicSectionSelect";
import EvaMultiDynamicSectionSelect from "./defined/EvaMultiDynamicSectionSelect";
import EvaWithSelected from "./defined/EvaWithSelected";
import EvaTest from "./defined/EvaTest";
import EvaMultiFile from "./defined/EvaMultiFile";
import EvaSingleFile from "./defined/EvaSingleFile";
import EvaUserSelect from "./defined/EvaUserSelect";
import EvaDynamicSelectFull from "./defined/EvaDynamicSelectFull";
import EvaDynamicSectionSelectFull from "./defined/EvaDynamicSectionSelectFull";
import EvaMultiUniversalSelect from "./defined/EvaMultiUniversalSelect";
import EvaUniversalSelect from "./defined/EvaUniversalSelect";
import EvaUniversalSelectFull from "./defined/EvaUniversalSelectFull";
import EvaMultiUniversalSelectFull from "./defined/EvaMultiUniversalSelectFull";
import EvaCategoryEditor from "./defined/EvaCategoryEditor";
import EvaColor from "./defined/EvaColor";
import EvaImport from "./defined/EvaImport";
import EvaExport from "./defined/EvaExport";
import EvaTextarea from "./defined/EvaTextarea";


customElements.define("eva-dynamic-select", EvaDynamicSelect);
customElements.define("eva-dynamic-select-full", EvaDynamicSelectFull);
customElements.define("eva-dynamic-section-select", EvaDynamicSectionSelect);
customElements.define("eva-dynamic-section-select-full", EvaDynamicSectionSelectFull);
customElements.define("eva-multi-dynamic-select", EvaMultiDynamicSelect);
customElements.define("eva-multi-dynamic-section-select", EvaMultiDynamicSectionSelect);
customElements.define("eva-multi-string", EvaMultiString);
customElements.define("eva-multi-integer", EvaMultiInteger);
customElements.define("eva-multi-date", EvaMultiDate);
customElements.define("eva-date", EvaDate);
customElements.define("eva-multi-file", EvaMultiFile);
customElements.define("eva-file", EvaSingleFile);
customElements.define("eva-test", EvaTest);
customElements.define("eva-with-selected", EvaWithSelected);
customElements.define("eva-user-select", EvaUserSelect);
customElements.define("eva-multi-universal-select", EvaMultiUniversalSelect);
customElements.define("eva-universal-select", EvaUniversalSelect);
customElements.define("eva-universal-select-full", EvaUniversalSelectFull);
customElements.define("eva-multi-universal-select-full", EvaMultiUniversalSelectFull);
customElements.define("eva-category-editor", EvaCategoryEditor);
customElements.define("eva-textarea", EvaTextarea);
customElements.define("eva-color", EvaColor);
customElements.define("eva-import", EvaImport);
customElements.define("eva-export", EvaExport);


// const root = ReactDOM.createRoot(document.getElementById('root'));
/*root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
